import { render } from "./sendMessageDialog.vue?vue&type=template&id=236f0d0e&scoped=true"
import script from "./sendMessageDialog.vue?vue&type=script&lang=js"
export * from "./sendMessageDialog.vue?vue&type=script&lang=js"

import "./sendMessageDialog.vue?vue&type=style&index=0&id=236f0d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236f0d0e"]])

export default __exports__